import React from "react";

const ContentWrapper = (props) => {
    return <div className="m-grid__item m-grid__item--fluid m-wrapper">{props.children}</div>
};
export default ContentWrapper;